import {EventItem} from "./event-item";
import {Organiser} from "./organizer";
import {RequestStatus} from "./request-status";
import {RequestTypes} from "./request-types";
import {UserDetail} from "./user-detail";
import {League} from "./league/league";

export class Request {
  id?: number;
  event?: EventItem;
  league?: League;
  requesterId?: number;
  requestStatus?: RequestStatus;
  type?: RequestTypes;
  comment?: string;
  organiserRequest?: Organiser;
  created?: Date;
  modified?: Date;
  userDetail?: UserDetail;

  public static createOrganiserRequest(organiser: Organiser): Request {
    var request: Request = new Request();
    request.organiserRequest = organiser;
    request.requestStatus = RequestStatus.ON_HOLD;
    request.type = RequestTypes.ORGANISER;
    return request;
  }

  public static createPublishEventRequest(eventItem: EventItem) {
    var request: Request = new Request();
    request.event = eventItem;
    request.requestStatus = RequestStatus.ON_HOLD;
    request.type = RequestTypes.PUBLISH_EVENT;
    return request;
  }

  public static createAddEventToLeagueRequest(eventItem: EventItem, league: League) {
    var request: Request = new Request();
    request.event = eventItem;
    request.league = league;
    request.requestStatus = RequestStatus.ON_HOLD;
    request.type = RequestTypes.ADD_EVENT_TO_LEAGUE;
    return request;
  }
}
